import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

function headersOrEmpty(headers) { return headers || {}; }

export async function getContactHistory(contactId, params = {}, headers) {
    const res = await axios.get(`${API}/contacts/${encodeURIComponent(contactId)}/history`, {
        params, headers: headersOrEmpty(headers),
    });
    return res.data;
}

export async function getEventAttendeeHistory(eventId, contactId, params = {}, headers) {
    const res = await axios.get(`${API}/events/${encodeURIComponent(eventId)}/history`, {
        params: { ...params, contact_id: contactId }, headers: headersOrEmpty(headers),
    });
    return res.data;
}

export async function getDealStageHistory(dealId, params = {}, headers) {
    const res = await axios.get(`${API}/deals/${dealId}/history`, {
        params, headers: headersOrEmpty(headers),
    });
    return res.data;
}

export { API as HISTORY_API };
